import React from "react";
import "../Styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col brand-col">
          <h2>Gain Wisdom</h2>
          <p><a href="Mailto:info@gainwissdom.in" target="_blank" rel="noreferrer">info@gainwissdom.in</a></p>
          <p>+91 9943936999</p>
        </div>

        <div className="footer-col">
          <h4>Socials</h4>
          <ul>
            <a href=" https://youtube.com/@jeseefrancis7779" className="anchar" target="_blank" rel="noreferrer"><li>YouTube</li></a>
            <a href="https://twitter.com/JeseeFrancis" className="anchar" target="_blank" rel="noreferrer"><li>Twitter</li></a>
            <a href="https://www.linkedin.com/in/jesee-francis-ab7622a" className="anchar" target="_blank" rel="noreferrer"><li>LinkedIn</li></a>
            <a href="https://www.instagram.com/jeseefrancis/" className="anchar" target="_blank" rel="noreferrer"><li>Instagram</li></a>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Other</h4>
          <ul>
            <a href="https://gainwisdom.in/" className="anchar" target="_blank" rel="noreferrer"><li>Gain Wisdom</li></a>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Resources</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About us</a></li>
            <li><a href="/#courses">Our Courses</a></li>
            <li><a href="/gallery">Gallery</a></li>
          </ul>
        </div>
      </div>

      <hr />
      <p className="footer-bottom">©2025 Gain Wisdom. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
